import PanelSubHeading from "../../components/panel/subHeading";
import React, { useEffect, useState } from "react";
import { EventCounts, statsBackend } from "../../services/stats"
import PieChart from "./charts/pieDiagram";
import { pieTestData } from "../../constants/events";
import { PieDiagramDataItem } from "../../constants/statistics";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducer";

export const generateNewPieData = (pieData: PieDiagramDataItem[], eventCounts: EventCounts): PieDiagramDataItem[] => {
  // Создаем копию pieData, чтобы не изменять исходный массив
  const newPieData = pieData.map((item) => ({ ...item, value: 0 }));
  // Проходим по eventsByType и суммируем count
  eventCounts.eventsByType.forEach((event) => {
    // Находим категорию, к которой относится type_id
    const category = newPieData.find((item) => item.type_ids.includes(event.type_id));
    if (category) {
      category.value += Number(event.count); // Увеличиваем значение value
    }
  });

  // Фильтруем массив, оставляя только элементы с value > 0
  return newPieData // .filter((item) => item.value > 0);
};

const TotalStatsRoundDiagram = () => {
  const  { rights } = useSelector((state: RootState) => state);
  const [displayData, setDisplayData] = useState<PieDiagramDataItem[]>([])
  const [diagramData, setDiagramData] = useState<EventCounts>({
    eventsByType: [],
    totalCount: 0
  });

  useEffect(() => {
    if (!rights) return;
    console.log("Rang:", rights.rang);
    if (rights.rang > 6) {
      statsBackend.getCompletedEventStats().then((res) => {
        setDisplayData(generateNewPieData(pieTestData, res.stats))
        setDiagramData(res.stats)
      });
      return;
    }
    if (rights.rang < 7 && rights.rang > 2) {
      const group = Math.min(...rights.group_ids);
      if (group === Infinity) {
        console.log("No group");
        return;
      }
      statsBackend.getCompletedEventStatsGlobal(group).then((res) => {
        setDisplayData(generateNewPieData(pieTestData, res.stats))
        setDiagramData(res.stats)
      });
      return;
    }
    if (rights.rang < 3)
    statsBackend.getCompletedEventStatsGlobal().then((res) => {
      setDisplayData(generateNewPieData(pieTestData, res.stats))
      setDiagramData(res.stats)
    })
  }, [rights]);

  if (diagramData.totalCount === 0) {
    return (
      <div className="panel" style={{ width: "100%" }}>
        <div className="inner gridCenter">
            <h3>Нет данных по событиям</h3>
        </div>
      </div>
    );
  }

  return (
    <div className="panel" style={{ width: "100%" }}>
      <div className="inner">
        <div className="flex between w100">
          <PanelSubHeading text={rights.rang < 3 ? "Статистика событий (все отделы)" : rights.rang < 7 ? "Статистика событий (отдел)" : "Статистика событий" }/>
          <div className="eventDateInfo headingDateInfo">
              {`Выполнено событий за текущий месяц - ${diagramData.totalCount}`}
          </div>
        </div>
        <div className="toDoHeadingBorder" style={{ marginTop: 6 }} />
        <div className="inner">
           <PieChart data={displayData} size={320} />
        </div>
      </div>
    </div>
  );
};

export default TotalStatsRoundDiagram;
